import { Box, Stack } from '@mui/material';
import {
  StaticHeaderContentStyles,
  StaticHeaderContentImageStyles,
  staticHeaderContentSupportContainer,
} from './StyledComponents';

export const StaticHeaderContent = ({ open, isMobile }) => (
  <Box className={`${open ? 'active' : ''}`} sx={StaticHeaderContentStyles}>
    <Stack
      direction={'row'}
      sx={{
        height: isMobile ? '3rem' : '2.25em',
        background: '#2CA6FA',
        borderRadius: '25px 0 0 25px',
        ...(isMobile && {
          width: '100%',
          borderRadius: '',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
        }),
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        gap={1}
        sx={{ padding: isMobile ? '' : '0 1rem 0 2rem', justifyContent: 'center' }}
      >
        <a
          href="https://www.linkedin.com/company/the-baltimore-life-insurance-company"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/images/linkedin.png" style={StaticHeaderContentImageStyles} />
        </a>
        <a href="https://www.facebook.com/BaltimoreLife" target="_blank" rel="noreferrer">
          <img src="/images/facebook.png" style={StaticHeaderContentImageStyles} />
        </a>
        <a
          href="https://www.instagram.com/BaltimoreLifeCompanies/"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/images/instagram.png" style={StaticHeaderContentImageStyles} />
        </a>
        <a href="https://twitter.com/BaltLife" target="_blank" rel="noreferrer">
          <img src="/images/twitter.png" style={StaticHeaderContentImageStyles} />
        </a>
      </Stack>
      <Box
        sx={{
          ...staticHeaderContentSupportContainer,
          borderRadius: isMobile ? '' : '25px 0 0 25px',
          padding: isMobile ? '' : '0 1rem 0 2rem',
        }}
      >
        <span>Support: (877) 533-2468</span>
      </Box>
    </Stack>
  </Box>
);
